import RightChevronIcon from "@/assets/colorable/right_chevron.svg?react";
import TextButton from "@/components/Common/TextButton";
import clsxm from "@/lib/clsxm";
import {Fragment, type FC} from "react";
import {useTranslation} from "react-i18next";

const ModalBreadcrumbs: FC<{
  className?: string;
  crumbs: {label: string; onClick?: () => void}[];
  onBack: () => void;
}> = ({className, crumbs, onBack}) => {
  const {t} = useTranslation("common");

  return (
    <div className={clsxm("text-neutral-black flex min-w-0 items-center gap-2 p-5", className)}>
      <TextButton
        aria-label={t("modalBack")}
        className="shrink-0"
        icon={<RightChevronIcon className="text-neutral-black size-3 shrink-0 rotate-180" />}
        onClick={onBack}
        text=""
      />
      {crumbs.map((crumb, index) => (
        <Fragment key={crumb.label}>
          {index > 0 && <span className="text-neutral-grey-light shrink-0 text-sm">/</span>}
          {index === crumbs.length - 1 ? (
            <span className="truncate text-sm font-medium">{crumb.label}</span>
          ) : (
            <TextButton
              className="enabled:text-neutral-grey-dark enabled:hover:text-neutral-black truncate text-sm font-normal"
              onClick={crumb.onClick ?? onBack}
              text={crumb.label}
            />
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default ModalBreadcrumbs;
